import { Injectable } from '@angular/core';
import { Ad, DefaultPromise } from '../models/ad';
import { HttpDao } from './http-dao';
import { HttpService } from 'src/app/core/http/http.service';
import { API } from 'src/app/configs';
import { PartialObserver, Subscription, BehaviorSubject } from 'rxjs';
import { LoggerService } from 'src/app/core/logger/logger.service';
import { Pagination } from '../utils/pagination';
import { GeneralService } from './general.service';
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { DialogActionComponent } from '../components/dialog-action/dialog-action.component';

@Injectable({
    providedIn: 'root'
})

export class AdService extends HttpDao<Ad, number> {

    private tagLoadAt: Date;
    private tag: any;
    private feature: any;
    private adList: any = null;
    private adData: any = {};
    public adDataOpen: any = {};

    protected subject: BehaviorSubject<any> = new BehaviorSubject(null);
    protected action: BehaviorSubject<any> = new BehaviorSubject(null);

    public action$ = this.action.asObservable();

    protected personDataSubscription: Subscription;

    public indexes: any = [
        { index_id: 0, title: 'Não indexado' }
    ];

    public correction_rounding: any = [
        { id: 0, title: 'Manter original' },
        { id: 1, title: 'Arredondar centena de milhar' },
        { id: 2, title: 'Arredondar dezena de milhar' },
        { id: 3, title: 'Arredondar milhar' },
        { id: 4, title: 'Arredondar centena' },
        { id: 5, title: 'Arredondar dezena' },
        { id: 6, title: 'Remover centavos' },
    ];

    public indexes_dates: any = [];

    constructor(httpService: HttpService,
        protected gs: GeneralService,
        private logger: LoggerService,
        protected router: Router,
        protected http: HttpClient,
        public dialog: MatDialog
    ) {
        super(httpService, API.ad['general'].base);


        super.setPath(this.getModule().base);

        this.personDataSubscription = this.gs.generalData$.subscribe((result) => {
            if (result?.adFeatures)
                this.feature = result.adFeatures;
        });

        if (this.indexes?.length == 1)
            this.indexes = this.indexes.concat(this.gs.settingsData?.indexes || []);
    }

    findAll(): Promise<Ad[]> {
        return this.find([]);
    }

    getModule() {
        return API.ad[this.router.url.split('/')[1] == 'admin' ? 'admin' : 'general'];
    }

    /**
     * Método para a busca de perssoas, com suporte a paginação.
     * @param filters Filtros para serem usados na busca de pessoas
     * @param initialPos Posição inicial do primeiro registro na lista de resultado
     * @param qtd Quantidade de registros que será retornado. Se -1 retornorá todos os registros filtrados
     * @returns Array de pessoas que corresponde ao filtro.
     */
    find(filters: any, initialPos: number = 0, qtd: number = -1): Promise<Ad[]> {
        return null;
    }

    newAd() {
        this.adDataOpen = { id: 0, status: 0, data: {} };
    }

    loadAds(pageSize: number, pageIndex: number, options: any = {}): Promise<any> {
        return this.httpService.post<AdList>(this.getModule().list, {
            type: 'edit',
            total_rows: pageSize,
            current_page: pageIndex,
            ...options
        }).catch((err) => this.gs.error(err));
    }

    loadListAd(): Promise<DefaultPromise[]> {
        //if(this.adList != null) return new DefaultPromise(this.adList).getData();

        return this.httpService.get(API.ad[this.gs.getModule()].base.setArgs([]), {}).then(result => {
            result = this.adjustFiles(result);
            return new DefaultPromise(result).getData();
        });
    }

    loadAd(id: number, owner_person_id: number = null): any {
        return this.httpService.post<any>(this.getModule().edit, { ad_id: id, owner_person_id: owner_person_id }).then(result => {
            if (typeof result['files'] !== 'undefined')
                result['files'] = this.adjustVariations(result['files']);

            this.adData[id] = result;

            return new DefaultPromise(result).getData();
        }).catch(err => console.log(err));
    }

    getAd(id: number, open = false) {
        if (this.adData[id] != undefined) {
            //            console.log(this.adData[id]);
            if (open)
                this.setAdOpen(this.adData[id]);

            return this.adData[id];
        }

        return false;
    }

    setAdOpen(ad) {
        ///console.log(ad);
        this.adDataOpen = ad;
    }

    adjustFiles(data: any) {
        for (var k in data)
            if (data.hasOwnProperty(k) && typeof data[k].files !== 'undefined') {
                data[k].files = this.adjustVariations(data[k].files);
            }

        return data;
    }

    adjustVariations(data: any) {

        for (var k in data)
            if (data.hasOwnProperty(k) && typeof data[k].variations !== 'undefined') {
                var variations = data[k].variations;
                for (var v in variations)
                    if (variations.hasOwnProperty(v)) {
                        data[k][variations[v].resizeType] = variations[v].name;
                    }
            }

        data.sort((a, b) => parseInt(a.sort) < parseInt(b.sort) ? -1 : parseInt(a.sort) > parseInt(b.sort) ? 1 : 0);

        return data;

    }

    /**
     * Permite a um observador se registrar para receber eventos do formulário.
     * @param observer Observadore que deseja se registrar.
     */
    subscribe(observer?: PartialObserver<any>): Subscription {
        return this.subject.subscribe(observer);
    }

    getList() {
        return this.adList;
    }

    // AD data from specific ID

    getName() {
        return this.adData.name;
    }

    getTags() {
        return this.adData.tags;
    }

    getData() {
        return this.adData.data;
    }

    getCreation() {
        return { creation: this.adData.creation, creator: this.adData.creator };
    }



    /*
        ACTIONS

  //Status atual: Não publicado(status==1) - Se usuário editou algo deve obrigar a cancelar ou salvar antes de fazer outras ações Opções:
    //Solicitar publicação -> Aguardando análise $new_status==5
    //Excluir -> $new_status==-5
    //Salvar -> $new_status====1

  //Status atual: Aguardando análise(status==5) Bloquear edições do anuncio - Opções:
    //#Administradores:
      //Analisar -> Analisando (status==4)
      //Cancelar publicação -> Não publicado($new_status==1)
    //#Usuários:
      //Cancelar publicação -> Não publicado($new_status==1)

  //Status atual: Analisando(status==4) Opções permitir alteração:
    //#Administradores:
      //Publicar -> Publicado($new_status==2)
      //Rejeitar publicação -> Não publicado $new_status==1  - Usuário deve receber notificação com os motivos
      //Cancelar publicação -> Não publicado($new_status==1)
    //#Usuários:
      //Cancelar publicação -> Não publicado($new_status==1)

  //Status atual: Publicado(status==2) - Opções:
    //Atualizar -> Aguardando análise(status==5)
    //Despublicar -> Não publicado($new_status==1)    

    */
    private buttonController = {
        update: [0, 1, 2, 4],
        publish: [1],
        analyse: [5],
        reject: [4],
        authorize: [4],
        delete: [1],
        undelete: [-5],
        pause: [2],
        cancel: [4, 5]
    };

    private buttonControllerToBack = {
        update: false,
        publish: this.gs.getModule() != 'admin',
        analyse: false,
        reject: true,
        authorize: true,
        delete: true,
        undelete: false,
        pause: false,//this.gs.getModule() != 'admin',
        cancel: true
    };

    private formControlDisabled = ["-5", "5", "2"];

    setActionSubscribe(fn): Subscription {
        console.log(fn);
        if (!this.action.observers.length) {
            return this.action$.subscribe(fn);
        }
        return null;
    }

    setAction(action) {
        console.log(action);
        this.action.next(action);
    }

    getActionAllowed(action, adminType = []) {
        return typeof this.adDataOpen.status !== 'undefined' && this.buttonController[action].indexOf(parseInt(this.adDataOpen.status)) > -1 && (!adminType.length || adminType.indexOf(this.gs.getModule()) > -1);
    }

    getActionToBack(action) {
        return this.buttonControllerToBack[action];
    }

    getFormControlDisabled(): boolean {
        return this.formControlDisabled.indexOf(this.adDataOpen.status) == -1;
    }

    executeAction(action, data, fthen, fcatch, ffinally): Promise<any> {
        switch (action) {
            case 'update': return this.updateAd(data).then(fthen).catch(fcatch).finally(ffinally);
            case 'updateUnits': return this.updateUnitsAd(data).then(fthen).catch(fcatch).finally(ffinally);
            case 'delete': return this.deleteAd(data).then(fthen).catch(fcatch).finally(ffinally);
            case 'undelete': return this.undeleteAd(data).then(fthen).catch(fcatch).finally(ffinally);
            case 'publish': return this.publishAd(data).then(fthen).catch(fcatch).finally(ffinally);
            case 'cancel': return this.cancelAd(data).then(fthen).catch(fcatch).finally(ffinally);
            case 'pause': return this.pauseAd(data).then(fthen).catch(fcatch).finally(ffinally);
            case 'analyse': return this.analyseAd(data).then(fthen).catch(fcatch).finally(ffinally);
            case 'reject': return this.rejectAd(data).then(fthen).catch(fcatch).finally(ffinally);
            case 'authorize': return this.authorizeAd(data).then(fthen).catch(fcatch).finally(ffinally);
            default: return null;
        }
    }

    private getOwnerPerson(obj: any = {}) {
        let companieSel = this.gs.getCompanieSel();
        return companieSel ? { owner_person_id: companieSel } : (obj?.owner_person_id ? { owner_person_id: obj.owner_person_id } : {});
    }
    /*
        saveAd(data: Ad): Promise<any>{
            return data.ad_id != 0 && data.ad_id != null? this.updateAd(data) : this.create(data);
        }*/

    updateAd(obj: Ad): Promise<any> {  //Atualizar -> Aguardando análise(status==5)
        if (typeof obj.ad_id == 'undefined')
            return this.create(obj);

        return this.httpService.put<any>(this.getModule().base, { ...obj, ...this.getOwnerPerson(obj) });
    }

    updateUnitsAd(obj: Ad): Promise<any> { //Atualizar disponibilidade
        return this.httpService.put<any>(this.getModule().units, { ...obj, ...this.getOwnerPerson(obj) });
    }

    deleteAd(obj: Ad): Promise<any> { //Excluir -> $new_status==-5
        return this.httpService.del<any>(this.getModule().base, { ad_id: obj.ad_id, ...this.getOwnerPerson(obj) });
    }

    undeleteAd(obj: Ad): Promise<any> { //Excluir -> $new_status==-5
        return this.httpService.del<any>(this.getModule().base.setArgs(['undo']), { ad_id: obj.ad_id, ...this.getOwnerPerson(obj) });
    }

    publishAd(obj: Ad): Promise<any> { //Publicar -> Publicado($new_status==2)
        return this.httpService.put<any>(this.getModule().publish, { ad_id: obj.ad_id, ...this.getOwnerPerson(obj) });
    }

    cancelAd(obj: Ad): Promise<any> { //Cancelar publicação -> Não publicado($new_status==1)
        return this.httpService.put<any>(this.getModule().cancel, { ad_id: obj.ad_id, ...this.getOwnerPerson(obj) });
    }

    pauseAd(obj: Ad): Promise<any> { //Despublicar -> Não publicado($new_status==1)   
        return this.httpService.put<any>(this.getModule().pause, { ad_id: obj.ad_id, ...this.getOwnerPerson(obj) });
    }

    analyseAd(obj: Ad): Promise<any> { //Analisar -> Analisando (status==4)
        if (!API.ad[this.gs.getModule()].analyse)
            throw new Error("Access denied");

        return this.httpService.put<any>(API.ad[this.gs.getModule()].analyse, { ad_id: obj.ad_id, ...this.getOwnerPerson(obj) });
    }

    rejectAd(obj: Ad): Promise<any> { //Rejeitar publicação -> Não publicado $new_status==1  - Usuário deve receber notificação com os motivos
        if (!API.ad[this.gs.getModule()].reject)
            throw new Error("Access denied");

        return this.httpService.put<any>(API.ad[this.gs.getModule()].reject, { ad_id: obj.ad_id, ...this.getOwnerPerson(obj) });
    }

    authorizeAd(obj: Ad): Promise<any> { //Rejeitar publicação -> Não publicado $new_status==1  - Usuário deve receber notificação com os motivos
        if (!API.ad[this.gs.getModule()].authorize)
            throw new Error("Access denied");

        return this.httpService.put<any>(API.ad[this.gs.getModule()].authorize, { ad_id: obj.ad_id, notify: obj?.notify, ...this.getOwnerPerson(obj) });
    }



    // ALL Features data

    getFeatureStatus(id) {
        return this.gs.getTags('featureStatus', false, id, 'tag');
    }

    getFeatureTypes(id: any = false) {
        var types = this.feature?.ad_type || [];
        //console.log(types, this.feature, id);

        if (!id)
            return types;

        if (!types.length)
            return false;

        return types.filter(item => parseInt(item.id) == parseInt(id))[0];

    }

    // ALL Tags data

    getFeature(type) {
        return this.tag.features.filter(item => item['type'] == type);
    }

    getStatus(id, type = 'ad') {
        return this.gs.getStatus(type, false, id, 'name');
    }

    getAmenities(type) {
        return this.tag.amenities.filter(item => item['type'] == type);
    }

    getRecreationArea(type) {
        return this.tag.recreationArea.filter(item => item['type'] == type);
    }

    getRecreationAreaLocale(type) {
        return this.tag.recreationAreaLocale.filter(item => item['type'] == type);
    }

    getUnitType(type) {
        return this.tag.unitType.filter(item => item['type'] == type);
    }

    getUnitStatus(type) {
        return this.tag.unitStatus.filter(item => item['type'] == type);
    }

    getPaymentMethod(type) {
        return this.tag.paymentMethod.filter(item => item['type'] == type);
    }

    adjustAds(list): Array<any> {
        return !list?.length ? [] : list.map(item => {
            item.statusName = this.getStatus(item.status);
            item.categoryName = this.gs.getFeatureCategory(item.ad_category_id, this.gs.getModule()).name;
            if (item?.cover) {
                item.cover = this.gs.adjustAvatarFiles({ avatar: item?.cover })[0];
                item.avatarFiles = { thumb: this.gs.getFileName(item?.cover, 'thumb') };
            }
            return item;
        });
    }


    async createBitLy(link, title, id: any = false) {

        const header: HttpHeaders = new HttpHeaders()
            .set('Authorization', 'Bearer 1daa9394d06b2e7232b7f51e7b58ca625175de55')
            .set('Content-Type', 'application/json');

        let body: any = {
            "group_guid": "Bl7nkKjtWKT",
            "domain": "bit.ly",
            "long_url": link,
            "title": title
        };


        if (id) {
            body = {
                "id": id,
                "long_url": link,
                "title": title
            };

            return await this.http.patch('https://api-ssl.bitly.com/v4/bitlinks' + (id ? '/' + id : ''), body, {
                headers: header,
                observe: 'response'
            }).toPromise();
        }

        return await this.http.post('https://api-ssl.bitly.com/v4/bitlinks' + (id ? '/' + id : ''), body, {
            headers: header,
            observe: 'response'
        }).toPromise();
    }


    async loadIndexes(data) {

        if (typeof this.indexes_dates[data.index_id] !== 'undefined')
            return new Promise((resolve, reject) => {
                return resolve(this.indexes_dates[data.index_id]);
            });

        return await this.httpService.post<any>(API.general.indexes, { index_id: data.index_id })
            .then((content) => {

                data.dates = content?.list?.map(val => {
                    val.month = new Date(val.start + ' 04:00:00+0000').toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' });
                    val.month = val.month.charAt(0).toUpperCase() + val.month.slice(1);
                    return val;
                });
                data.loaded = true;

                this.indexes_dates[data.index_id] = data;

                return data;
            })
            .catch((error) => {
                this.gs.error(error);
                throw error;
            });
    }


    updateIndexMonth(month, callback = null) {
        if (!month)
            return;

        const dialogRef = this.dialog.open(DialogActionComponent,
            {
                data: {
                    title: 'Deseja atualizar a tabela com base nesse mês?',
                    content: 'Unidades que não possuem índice preenchido será calculado com base no valor',
                    cancelTitle: 'Não',
                    okTitle: 'Sim',
                    okClass: 'btn-danger',
                    disableClose: true
                }
            });

        dialogRef.afterClosed().subscribe(result => {
            if (result && typeof callback === 'function') {
                callback(result);
            }
        });
    }

    calcAmount(amount, round) {

        if (typeof amount == 'undefined')
            amount = '0.00';

        if (round) {
            switch (round.id) {
                case 1:
                    amount = Math.round(amount / 100000) * 100000;
                    break;
                case 2:
                    amount = Math.round(amount / 10000) * 10000;
                    break;
                case 3:
                    amount = Math.round(amount / 1000) * 1000;
                    break;
                case 4:
                    amount = Math.round(amount / 100) * 100;
                    break;
                case 5:
                    amount = Math.round(amount / 10) * 10;
                    break;
                case 6:
                    amount = amount.substr(0, amount.indexOf('.')) + '.00';
                    break;
            }
        }

        return amount;
    }
}

export class AdList {
    list: any[];
    total: Pagination;

}
